// extracted by mini-css-extract-plugin
export var chip = "_f0-0";
export var filterDropdown = "_f0-5";
export var filterItem = "_f0-6";
export var icon = "_f0-1";
export var removeButton = "_f0-3";
export var removeIcon = "_f0-4";
export var separator = "_f0-2";